// Angular
import {
  Component,
  ElementRef,
  inject,
  Input,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
// Models
import { ControlsOf } from '@shared/models-v3/controls-of.type';
import { RecipientAnother } from './models/recipient-another.interface';
// PrimeNG
import { InputTextModule } from 'primeng/inputtext';
// Components
import { DocumentIdInputComponent } from '@shared/components-v3/atomic/document-id-input/document-id-input.component';
import { PhoneInputComponent } from '@shared/components-v3/atomic/phone-input/phone-input.component';
import { NameInputComponent } from '@shared/components-v3/atomic/name-input/name-input.component';
// Directives
import { FormSubmitDirective } from '@shared/directives-v3/validation-message/directives/form-submit/form-submit.directive';
import { ControlErrorsDirective } from '@shared/directives-v3/validation-message/directives/control-errors/control-errors.directive';
// Services
import { CheckoutService } from '../../../../services/checkout/checkout.service';
import { environment } from '@env/environment';
import { CheckoutStorageService } from 'src/app/checkout-v2/services/checkout-storage/checkout-storage.service';

const NG_MODULES = [ReactiveFormsModule];
const PRIME_MODULES = [InputTextModule];
const COMPONENTS = [
  DocumentIdInputComponent,
  PhoneInputComponent,
  NameInputComponent,
];
const DIRECTIVES = [FormSubmitDirective, ControlErrorsDirective];

/**
 * Componente para ingresar los datos de la persona que recibe o retira el pedido.
 */
@Component({
  selector: 'app-recipient-another-form',
  standalone: true,
  imports: [NG_MODULES, PRIME_MODULES, COMPONENTS, DIRECTIVES],
  templateUrl: './recipient-another-form.component.html',
  host: { class: 'w-full' },
})
export class RecipientAnotherFormComponent {
  @ViewChild('recipientAnotherFormElement')
  recipientAnotherFormElement!: ElementRef;
  @Input() set recipient(value: RecipientAnother | null) {
    this.setRecipient(value);
  }
  recipientAnotherForm!: FormGroup<ControlsOf<RecipientAnother>>;
  documentIdLabel = environment.documentId.personalLabel;
  documentIdSample = environment.documentId.personalSample;

  //#region Dependencies
  public readonly checkoutService = inject(CheckoutService);
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly checkoutStorageService = inject(CheckoutStorageService);
  //#endregion

  constructor() {
    this.buildForm();
  }

  private buildForm(): void {
    this.recipientAnotherForm = this.fb.group({
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      documentId: ['', Validators.required],
      phone: ['', Validators.required],
    });
  }

  private setRecipient(recipient: RecipientAnother | null): void {
    if (!recipient) return;
    this.recipientAnotherForm.setValue({
      name: recipient.name,
      lastName: recipient.lastName,
      documentId: recipient.documentId,
      phone: recipient.phone,
    });
  }
  /**
   * Método que se ejecuta al enviar el formulario.
   */
  submit(): boolean {
    this.recipientAnotherFormElement.nativeElement.dispatchEvent(
      new Event('submit', { bubbles: true, cancelable: true })
    );
    return this.recipientAnotherForm.valid;
  }

  nativeSubmit(): void {
    if (this.recipientAnotherForm.valid) {
      const receiver = this.recipientAnotherForm.getRawValue();
      this.checkoutStorageService.setRecipientAnother(receiver);
    } else {
      this.recipientAnotherForm.markAllAsTouched();
    }
  }
}
